/* eslint-disable @typescript-eslint/camelcase */
import { GraphPayload } from '../Visualisation/types'

export enum ChartName {
  contacts_per_item = 'contacts_per_item',
  views_per_item = 'views_per_item',
  cost_viewing = 'cost_viewing',
  conversion_contact_from_viewing = 'conversion_contact_from_viewing',
  average_price_category_item = 'average_price_category_item',
  cpm = 'cpm',
  cpc = 'cpc',
  coverage = 'coverage',
  inclusion = 'inclusion',
  cost = 'cost',
  posev_top_5 = 'posev_top_5',
  price_per_advertiser = 'price_per_advertiser',
  integration_per_advertiser = 'integration_per_advertiser',
  posev_rest = 'posev_rest',
  posev_expenses = 'posev_expenses',
  integration_count = 'integration_count'
}

/** @NOTE изменил */
export type RequestPayload = {
  data: {
    contacts_per_item: GraphPayload
    views_per_item: GraphPayload
    cost_viewing: GraphPayload
    conversion_contact_from_viewing: GraphPayload
    average_price_category_item: GraphPayload
    cpm: GraphPayload // Стоимость 1000 показов (CPM) в Telegram
    cpc: GraphPayload // Стоимость клика (CPC) в Telegram
    coverage: GraphPayload // Какой охват получает интеграция
    inclusion: GraphPayload // Насколько интеграция вовлекает аудиторию
    cost: GraphPayload // Сколько стоит рекламная интеграция

    //Сколько рекламодатели из топ-5 тратят на посевы в Telegram-каналах
    posev_top_5: {
      // Средние затраты на рекламодателя
      price_per_advertiser: GraphPayload
      // Количество интеграций на рекламодателя
      integration_per_advertiser: GraphPayload
    }
    // Сколько остальные рекламодатели тратят на посевы в Telegram-каналах
    posev_rest: {
      // Средние затраты на рекламодателя
      price_per_advertiser: GraphPayload
      // Количество интеграций на рекламодателя
      integration_per_advertiser: GraphPayload
    }
    // Затраты на посевы (проценты)
    posev_expenses: { top5: number; rest: number }
    // Количество интеграций
    integration_count: { top5: number; rest: number }
  }
  period: { min: Date; max: Date } // минимальный и максимальный период календаря (от куда - до куда данные)
  theme: { id: number; name: string }[] // Тематика бизнеса
}
